import React, { useRef } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { ssrFailureDisplayEntryPoint } from './entrypoint.tsx';

const EMPTY_OBJECT = {};

const LoadEntryPoint = () => {
	const hasLoadedEntryPoint = useRef(false);

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		ssrFailureDisplayEntryPoint,
		EMPTY_OBJECT,
	);

	// Docs say to do this not in an effect :/ https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138515/Deprecated+Tutorial+How+to+render+your+EntryPoint+for+async+components#Option-3%3A-Using-useRef-without-user-interaction
	// And they have eslint rules to enforce it
	if (!hasLoadedEntryPoint.current) {
		hasLoadedEntryPoint.current = true;
		entryPointActions.load();
	}

	return (
		<JiraEntryPointContainer
			id="ssr-failure-display"
			packageName="@atlassian/jira-ssr-render-guard"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={EMPTY_OBJECT}
		/>
	);
};

export const AsyncSSRFailureDisplay = () => {
	if (!fg('staging-only-show-ssr-error')) {
		return null;
	}
	return <LoadEntryPoint />;
};

AsyncSSRFailureDisplay.displayName = 'AsyncSSRFailureDisplay';
